import { CLOUDINARY_CLOUD_NAME } from './cloudinary';

const CLOUDINARY_IMAGE_BASE = `https://res.cloudinary.com/${CLOUDINARY_CLOUD_NAME}/image/upload`;

/** Home section animated GIFs — URL strings only (never `import` remote URLs). */
export const AI_SOLUTIONS_DIAGRAM_GIF = `${CLOUDINARY_IMAGE_BASE}/v1779300497/Databiqas-Animation1_dkxylz.gif`;

export const AI_AUTOMATION_DIAGRAM_GIF = `${CLOUDINARY_IMAGE_BASE}/v1779300253/Databiqas-Animation_c9e1am.gif`;
